/*
 * "Picked for you" and "Recently viewed" rows for the home page (sections/ts-picks.liquid).
 *
 * No app and no account: the products a visitor looks at are remembered in their own browser (localStorage, nothing is sent to us).
 * - Recently viewed: the last products viewed.
 * - Picked for you: Shopify's "related" suggestions for the last products viewed or saved to the wishlist, kept only when they share the
 *   brand or tags of what the visitor looked at, and never what they already viewed.
 * Nothing is recorded when the visitor declined cookies in the cookie banner. Rows with nothing to show stay hidden.
 */
(function () {
  var VIEW_KEY = 'ts:viewed:v1';
  var WISH_KEY = 'ts:wishlist:v2';
  var MAX_VIEWED = 24;
  var GENERIC = ['store-wide', 'price-drop', 'clearance', 'gifts', 'salon supplies', 'travel', 'new', 'sale', 'men'];

  function consentDenied() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_pandectes_gdpr=([^;]+)/);
      if (!m) return false;
      var data = JSON.parse(atob(decodeURIComponent(m[1])));
      return data && data.status === 'deny';
    } catch (e) {
      return false;
    }
  }

  function readJSON(key, fallback) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || 'null');
      return v == null ? fallback : v;
    } catch (e) {
      return fallback;
    }
  }

  function recordView() {
    var el = document.getElementById('ts-view-data');
    if (!el || consentDenied()) return;
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.h) return;
    var list = readJSON(VIEW_KEY, []).filter(function (x) {
      return x && x.h !== data.h;
    });
    list.unshift({ h: data.h, t: Date.now() });
    try {
      localStorage.setItem(VIEW_KEY, JSON.stringify(list.slice(0, MAX_VIEWED)));
    } catch (e) {}
  }

  function productJSON(handle, root) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function relatedJSON(id, root) {
    return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (d) {
        return d.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function complementaryJSON(id, root) {
    return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=complementary')
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (d) {
        return d.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function realTags(p) {
    return (p.tags || [])
      .map(function (t) {
        return String(t).toLowerCase();
      })
      .filter(function (t) {
        return GENERIC.indexOf(t) === -1;
      });
  }

  function baseTitle(p) {
    return String(p.title || '').split(' - ')[0].trim().toLowerCase();
  }

  function money(cents, container) {
    var amount = (cents / 100).toFixed(2);
    if (container.dataset.locale === 'fr') return amount.replace('.', ',') + ' $';
    return 'C$' + amount;
  }

  function imageUrl(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=420';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function cardHTML(p, container) {
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var url = container.dataset.root + 'products/' + p.handle;
    var d = container.dataset;
    var variants = p.variants || [];
    var single = variants.length === 1 && variants[0].available !== false ? variants[0] : null;
    var action = single
      ? '<button type="button" class="ts-picks__qa" data-variant="' + single.id + '" data-product="' + p.id + '">' + esc(d.labelQuick) + '</button>'
      : '<a class="ts-picks__qa" href="' + esc(url) + '">' + esc(d.labelChoose) + '</a>';
    return (
      '<li class="ts-picks__card">' +
      '<div class="ts-picks__media">' +
      '<a class="ts-picks__imglink" href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><span class="ts-picks__img">' +
      (onSale ? '<span class="ts-picks__badge">' + esc(d.saleLabel) + '</span>' : '') +
      (p.featured_image ? '<img src="' + esc(imageUrl(p.featured_image)) + '" alt="" loading="lazy" width="420">' : '') +
      '</span></a>' +
      '<ts-wishlist-button class="ts-wishlist-card" data-product-id="' + esc(p.id) + '" data-product-handle="' + esc(p.handle) +
      '" data-label-add="' + esc(d.labelWishAdd) + '" data-label-remove="' + esc(d.labelWishRemove) + '">' +
      '<button type="button" class="ts-wishlist-card__button" aria-pressed="false" aria-label="' + esc(d.labelWishAdd) + '">' +
      '<svg class="ts-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.5 4.04 3 5.5l7 7Z"/></svg>' +
      '</button></ts-wishlist-button>' +
      action +
      '</div>' +
      '<a class="ts-picks__text" href="' + esc(url) + '">' +
      '<span class="ts-picks__vendor">' + esc(p.vendor) + '</span>' +
      '<span class="ts-picks__title">' + esc(p.title) + '</span>' +
      '<span class="ts-picks__price">' + esc(money(p.price, container)) +
      (onSale ? ' <s>' + esc(money(p.compare_at_price, container)) + '</s>' : '') + '</span>' +
      '</a></li>'
    );
  }

  // Quick add: adds the product's only variant and tells the cart drawer, the same way the duos page and the free gift strip do.
  async function quickAdd(button) {
    var d = button.closest('[data-ts-picks]').dataset;
    var id = Number(button.dataset.variant);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var ok = false;
    try {
      var events = await import('@shopify/events');
      var CartLinesUpdateEvent = events.CartLinesUpdateEvent;
      var deferred = CartLinesUpdateEvent.createPromise();
      button.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }],
        promise: deferred.promise,
      }));
      var sectionIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component'))
        .map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
        });
        var data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
        var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'ts-picks', sourceId: 'ts-picks', itemCount: 1, productId: button.dataset.product, sections: data.sections, didError: false },
        });
        ok = true;
      } catch (err) {
        deferred.reject(err);
      }
    } catch (err) {
      ok = false;
    }
    button.textContent = ok ? d.labelAdded : d.labelQuick;
    setTimeout(function () {
      button.textContent = d.labelQuick;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }, ok ? 2200 : 0);
  }

  document.addEventListener('click', function (e) {
    var qa = e.target.closest && e.target.closest('button.ts-picks__qa');
    if (qa && !qa.disabled) quickAdd(qa);
  });

  function show(container, products) {
    var track = container.querySelector('[data-ts-track]');
    track.innerHTML = products.map(function (p) {
      return cardHTML(p, container);
    }).join('');
    container.hidden = false;
    wireArrows(container);
  }

  function wireArrows(container) {
    var track = container.querySelector('[data-ts-track]');
    var prev = container.querySelector('[data-ts-prev]');
    var next = container.querySelector('[data-ts-next]');
    function step() {
      var card = track.querySelector('.ts-picks__card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      prev.hidden = next.hidden = track.scrollWidth <= track.clientWidth + 2;
    }
    prev.onclick = function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); };
    next.onclick = function () { track.scrollBy({ left: step(), behavior: 'smooth' }); };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function buildRecent(container) {
    var root = container.dataset.root;
    var max = Number(container.dataset.max) || 12;
    var handles = readJSON(VIEW_KEY, []).map(function (x) { return x.h; }).slice(0, max);
    if (!handles.length) return;
    Promise.all(handles.map(function (h) { return productJSON(h, root); })).then(function (list) {
      var seenBase = {};
      var items = list.filter(Boolean).filter(function (p) {
        var b = baseTitle(p);
        if (seenBase[b]) return false;
        seenBase[b] = true;
        return true;
      });
      if (items.length) show(container, items);
    });
  }

  // Words that name what a product is, used to find other brands' products of the same kind (a "Redken shampoo" looks for shampoos).
  var KINDS = ['shampoo', 'conditioner', 'serum', 'mask', 'oil', 'spray', 'gel', 'cream', 'treatment', 'polish', 'lacquer', 'brush',
    'dryer', 'straightener', 'mousse', 'wax', 'pomade', 'cleanser', 'moisturizer', 'toner', 'lotion', 'balm', 'foundation', 'mascara',
    'lipstick', 'primer', 'scrub', 'shampooing', 'revitalisant'];
  var MAX_PER_BRAND = 2;

  function kindOf(p) {
    var t = String(p.title || '').toLowerCase();
    for (var i = 0; i < KINDS.length; i++) {
      if (new RegExp('\\b' + KINDS[i] + 's?\\b').test(t)) return KINDS[i];
    }
    return '';
  }

  function suggestJSON(query, root) {
    return fetch(
      root + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide',
      { headers: { Accept: 'application/json' } }
    )
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        return (d && d.resources && d.resources.results && d.resources.results.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function buildPicks(container) {
    var root = container.dataset.root;
    var max = Number(container.dataset.max) || 12;
    var viewed = readJSON(VIEW_KEY, []).map(function (x) { return x.h; });
    var wished = readJSON(WISH_KEY, []).map(function (x) { return x && x.handle; }).filter(Boolean);
    var seeds = viewed.slice(0, 3);
    wished.slice(0, 2).forEach(function (h) { if (seeds.indexOf(h) === -1) seeds.push(h); });
    if (!seeds.length) return;
    var known = {};
    viewed.concat(wished).forEach(function (h) { known[h] = true; });

    Promise.all(seeds.map(function (h) { return productJSON(h, root); })).then(function (seedProducts) {
      seedProducts = seedProducts.filter(Boolean);
      if (!seedProducts.length) return;
      var vendors = {};
      var tags = {};
      var types = {};
      var kinds = {};
      var seenBase = {};
      seedProducts.forEach(function (p) { seenBase[baseTitle(p)] = true; });
      seedProducts.forEach(function (p, i) {
        var weight = 3 - Math.min(i, 2);
        vendors[p.vendor] = (vendors[p.vendor] || 0) + weight;
        if (p.type) types[p.type] = (types[p.type] || 0) + 1;
        var k = kindOf(p);
        if (k) kinds[k] = true;
        realTags(p).forEach(function (t) { tags[t] = (tags[t] || 0) + 1; });
      });

      // Pools: Shopify's related and complementary suggestions for each product (same brand and line, other categories), plus other brands'
      // products of the same kind, so the row has variety instead of one brand.
      var jobs = [];
      seedProducts.forEach(function (p) {
        jobs.push(relatedJSON(p.id, root).then(function (l) { return { list: l, source: 'related' }; }));
        jobs.push(complementaryJSON(p.id, root).then(function (l) { return { list: l, source: 'complementary' }; }));
      });
      Object.keys(kinds).forEach(function (k) {
        jobs.push(suggestJSON(k, root).then(function (l) { return { list: l, source: 'kind' }; }));
      });

      return Promise.all(jobs).then(function (pools) {
        var seen = {};
        var candidates = [];
        pools.forEach(function (pool) {
          pool.list.forEach(function (c) {
            if (!c || seen[c.handle] || known[c.handle] || c.available === false) return;
            if (seenBase[baseTitle(c)]) return;
            seenBase[baseTitle(c)] = true;
            seen[c.handle] = true;
            var kind = kindOf(c);
            // little weight on the brand: a brand the visitor looked at is a hint, not the whole row
            var score = (vendors[c.vendor] ? 1 : 0) + (types[c.type] ? 2 : 0) + (kind && kinds[kind] ? 2 : 0) + (pool.source === 'complementary' ? 1 : 0);
            var shared = 0;
            realTags(c).forEach(function (t) { if (tags[t]) shared++; });
            score += Math.min(shared, 3);
            candidates.push({ p: c, score: score, kind: c.type || kind, vendor: c.vendor, source: pool.source });
          });
        });
        candidates = candidates.filter(function (x) { return x.score > 0; });

        // Greedy pick: best score first, but never more than two from one brand, and each extra product of an already picked brand or
        // kind is marked down so the row mixes brands and categories.
        var perBrand = {};
        var perKind = {};
        var chosen = [];
        while (chosen.length < max && candidates.length) {
          var bestIndex = -1;
          var bestScore = -Infinity;
          for (var i = 0; i < candidates.length; i++) {
            var c = candidates[i];
            if ((perBrand[c.vendor] || 0) >= MAX_PER_BRAND) continue;
            var adjusted = c.score - 3 * (perBrand[c.vendor] || 0) - (c.kind ? (perKind[c.kind] || 0) : 0);
            if (adjusted > bestScore) {
              bestScore = adjusted;
              bestIndex = i;
            }
          }
          if (bestIndex < 0) break;
          var pick = candidates.splice(bestIndex, 1)[0];
          perBrand[pick.vendor] = (perBrand[pick.vendor] || 0) + 1;
          if (pick.kind) perKind[pick.kind] = (perKind[pick.kind] || 0) + 1;
          chosen.push(pick);
        }
        if (chosen.length < 4) return;

        // Search suggestions do not carry variants and prices in the same form: load the full product for those picks.
        return Promise.all(chosen.map(function (x) {
          return x.source === 'kind' ? productJSON(x.p.handle, root) : Promise.resolve(x.p);
        })).then(function (picks) {
          picks = picks.filter(function (p) { return p && p.available !== false; });
          if (picks.length >= 4) show(container, picks);
        });
      });
    });
  }

  function init() {
    recordView();
    if (consentDenied()) return;
    document.querySelectorAll('[data-ts-picks]').forEach(function (container) {
      if (container.dataset.mode === 'recent') buildRecent(container);
      else buildPicks(container);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
